import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import MetricCard from "examples/Cards/MetricCard";

/**
 * MetricCardsContainer Component
 * Renders a dynamic grid of MetricCards based on the provided profiles' metrics.
 *
 * @param {Array} metrics - Array of profile metric objects [{ profilePic, name, metricName, metricValue, previousMetricValue }]
 */
function MetricCardsContainer({ metrics }) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexWrap="wrap"
      gap={2}
      px={2}
      mt={3}
    >
      {metrics.map((metric, index) => (
        <Box key={index} sx={{ flex: "1 1 calc(20% - 16px)", minWidth: "250px", maxWidth: "300px" }}>
          <MetricCard
            profilePic={metric.profilePic}
            name={metric.name}
            platform={metric.platform}
            metricLabel={metric.metricName}
            metricValue={metric.metricValue}
            previousMetricValue={metric.previousMetricValue}
            isQualitative={metric.isQualitative} // ✅ Pass new prop
          />
        </Box>
      ))}
    </Box>
  );
}

// 🛡️ PropTypes Validation
MetricCardsContainer.propTypes = {
  metrics: PropTypes.arrayOf(
    PropTypes.shape({
      profilePic: PropTypes.string,
      name: PropTypes.string.isRequired,
      metricName: PropTypes.string.isRequired,
      metricValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      previousMetricValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ).isRequired,
};

export default MetricCardsContainer;
